// Orari nel formato 'HH:mm': con le ore a due cifre l'ordine alfabetico è quello cronologico

// Unione degli orari di più centri, senza doppioni e in ordine
export const mergeHours = (lists: string[][]): string[] =>
  Array.from(new Set(lists.flat())).sort();

// "Nessun orario" solo se l'unione è vuota e nessun centro sta ancora caricando gli orari
// del giorno: un centro che deve ancora rispondere può avere orari liberi
export const shouldShowNoHours = (
  hours: string[],
  loadingIds: string[]
): boolean => hours.length === 0 && loadingIds.length === 0;

export interface SurroundingHours {
  before?: string;
  after?: string;
}

// Orari liberi più vicini a quello cercato, uno prima e uno dopo nello stesso giorno
export const findSurroundingHours = (
  times: string[],
  target: string
): SurroundingHours => {
  const sorted = Array.from(new Set(times)).sort();
  return {
    before: sorted.filter((time) => time < target).pop(),
    after: sorted.find((time) => time > target),
  };
};
